import type { MailboxInfo } from "owa-client-types";
import { isOfflineSyncEnabled } from "./isOfflineSyncEnabled";
import { isOfflineSearchIndexingEnabled } from "./isOfflineSearchIndexingEnabled";

export function isOfflineSearchEnabled(mailboxInfo: MailboxInfo): boolean {
    return (isOfflineSyncEnabled(mailboxInfo) && isOfflineSearchIndexingEnabled() && !!Intl.Segmenter);
}
